export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9433.7e40cf4c.jpg";